import type React from 'react'
import {
  AppstoreOutlined,
  BarChartOutlined,
  DashboardOutlined,
  GroupOutlined,
  LineChartOutlined,
  PieChartOutlined,
  TableOutlined,
} from '@ant-design/icons'
import { createElement } from 'react'
import type { DashboardWidget, DashboardWidgetType } from './types'

type VizSwitcherEntry = {
  key: DashboardWidgetType
  icon: React.ReactNode
  label: string
}

export const VIZ_SWITCHER: VizSwitcherEntry[] = [
  { key: 'kpi', icon: createElement(AppstoreOutlined), label: 'KPI' },
  { key: 'bar', icon: createElement(BarChartOutlined), label: 'Bar' },
  { key: 'groupedBar', icon: createElement(GroupOutlined), label: 'Grouped' },
  { key: 'line', icon: createElement(LineChartOutlined), label: 'Line' },
  { key: 'donut', icon: createElement(PieChartOutlined), label: 'Donut' },
  { key: 'gauge', icon: createElement(DashboardOutlined), label: 'Gauge' },
  { key: 'table', icon: createElement(TableOutlined), label: 'Table' },
  { key: 'dataBarTable', icon: createElement(TableOutlined), label: 'Data Bar Table' },
  { key: 'pivotTable', icon: createElement(TableOutlined), label: 'Pivot Table' },
]

/**
 * The views a widget can be switched to. A gauge reads the two measures its contract names as
 * actual and target, so it is only offered on widgets that already are gauges.
 */
export function getVizSwitcherOptions(widget: Pick<DashboardWidget, 'type'>, availableTypes: DashboardWidgetType[]) {
  return VIZ_SWITCHER.filter((entry) => availableTypes.includes(entry.key) && (entry.key !== 'gauge' || widget.type === 'gauge'))
}
